import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Hls from 'hls.js';

const config = {
  maxBufferHole: 0,
  maxLoadingDelay: 1000,
};

const Video = ({ src, id, ...rest }) => {
  const [videoElement, setVideoElement] = useState(null);
  const [hlsObjects] = useState([new Hls(config)]);

  useEffect(() => {
    const loadVideo = () => {
      if (!src || !id) return;
      const hlsObject = hlsObjects[hlsObjects.length - 1];
      let newVideoElement = null;
      if (videoElement) {
        videoElement.setAttribute('src', src);
      } else {
        newVideoElement = document.getElementById(id);
        newVideoElement.setAttribute('src', src);
      }
      hlsObject.loadSource(src);
      hlsObject.attachMedia(videoElement);

      if (!videoElement) setVideoElement(newVideoElement);
    };
    loadVideo();
  }, [hlsObjects, id, src, videoElement]);
  if (!src || !id) return null;
  return <video id={id} {...rest} />;
};

Video.propTypes = {
  src: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default Video;
